import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useFirebase } from 'components/Firebase/index.js';
import { useAlert } from 'contexts/AlertContext.jsx';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import useOrgId from 'hooks/useOrgId.js';

const useUpdateUserMutation = () => {
  const { t } = useLocalization();
  const firebase = useFirebase();
  const orgId = useOrgId();
  const uid = useSelector((state) => state.sessionState.authUser?.uid);
  const queryClient = useQueryClient();
  const { setAlert } = useAlert();

  return useMutation({
    mutationFn: async (patch) => {
      const agent = await firebase.getAgent();
      const { body } = await agent.patch(`/o/${orgId}/users/${uid}`).send(patch);

      return {
        fullName: body.user.fullName || '',
        displayName: body?.orgUser?.displayName || '',
        avatar: body?.orgUser?.avatar?.url || null,
        jobTitle: body?.orgUser?.jobTitle || '',
        email: body?.orgUser?.email || body.user.email || '',
        calendarId: body?.orgUser?.calendarId || '',
        calendars: body?.orgUser?.calendars || [],
        roles: body?.orgUser?.roles || [],
        locale: body?.user?.locale || '',
        optOutPlatformEmails: body?.orgUser?.optOutPlatformEmails || false,
      };
    },
    onError: (error) => {
      console.error(error);
      setAlert({ title: t('genericLabels.error'), variant: 'danger' });
    },
    onSuccess: (response) => {
      queryClient.setQueryData(['o', orgId, 'user', uid], (oldData) => ({ ...oldData, ...response }));
    },
  });
};

export default useUpdateUserMutation;
